import type { CSSProperties, PropsWithChildren } from 'react'

import { type ThemeBackground, themeBackgroundMap } from '@mntn-dev/ui-theme'
import { cn } from '@mntn-dev/ui-utilities'
import { forwardRef } from '../../utils/forward-ref.ts'

type TableBodyProps = PropsWithChildren<{
  className?: string
  background?: ThemeBackground | null
  style?: CSSProperties
}>

const TableBody = forwardRef<HTMLTableSectionElement, TableBodyProps>(
  (
    { className = '', background = 'container-secondary', children, style },
    ref
  ) => {
    return (
      <tbody
        ref={ref}
        className={cn(background && themeBackgroundMap[background], className)}
        style={style}
      >
        {children}
      </tbody>
    )
  }
)

export { TableBody, type TableBodyProps }
